import { render, staticRenderFns } from "./testAddFormItem.vue?vue&type=template&id=14fd2c31&scoped=true&"
import script from "./testAddFormItem.vue?vue&type=script&lang=js&"
export * from "./testAddFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fd2c31",
  null
  
)

export default component.exports